<template>
  <div>
    <el-upload
      class="upload-demo"
      drag
      action="1"
      :headers="{
        loginUserToken: Storage.l.get('TokenKey'),
      }"
      show-file-list
      :on-exceed="handleExceed"
      :before-upload="beforeUpload"
      :on-preview="handlePreview"
      :on-change="handleChange"
      :on-remove="handleRemove"
      :before-remove="beforeRemove"
      :on-success="handleSuccess"
      :limit="40"
      accept=".xls, .xlsx"
      :file-list="fileList"
      :auto-upload="false"
      multiple
    >
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      <div class="el-upload__tip" slot="tip">
        只能上传excel文件，且不超过40M
      </div>
    </el-upload>
    <div class="flex" v-if="fileList.length">
      <el-upload
        class="upload-demo"
        action="1"
        disabled
        :auto-upload="false"
        :file-list="fileList"
      >
      </el-upload>
    </div>
    <div v-html="formConfig.exportMessage"></div>
    <div class="dialog-footer">
      <el-button
       v-if="flag"
        type="primary"
        :loading="uploadLoading"
        @click="startUpload(false)"
        size="small"
        >开始上传
      </el-button>
      <el-button
       v-else
        type="info" plain
        :loading="false"
        size="small"
        >开始上传
      </el-button>
      <!-- <el-button
        type="primary"
        @click="startUpload(true)"
        size="small"
        >测试
      </el-button> -->
      <el-button
        type="primary"
        @click="download_modal"
        size="small"
        >下载模板
      </el-button>
      <el-button
        type="danger"
        @click="dialog_btnClose"
        size="small"
        icon="el-icon-close"
        >关闭</el-button
      >
    </div>
  </div>
</template>
<script>
import ReconnectingWebSocket from 'reconnecting-websocket';
import request, { portUrl, websocketUrl } from '../../../../../../utils/request';
import Storage from '../../../../../../utils/storage';

export default {
  name: 'ExportModal',
  props: {
    formConfig: Object,
    modalConfig: Object,
  },
  data() {
    return {
      Storage,
      fileList: [],
      tableList: [],
      isUpload: false,
      files: [],
      uploadLoading: false,
      flag: true,
    };
  },
  created() {
    this.createWebsocket();
  },
  watch: {
    formConfig: {
      deep: true,
      handler(val) {
        this.createWebsocket();
      },
    },
    modalConfig: {
      deep: true,
      handler(val) {
        console.log(val);
      },
    },
  },
  methods: {
    /** @desc 按钮关闭事件 */
    dialog_btnClose() {
      this.$emit('onClose');
      this.$parent.modalName = null;
      this.closeWebSocket();
      this.$forceUpdate();
    },
    // 下载模板
    download_modal() {
      const a = document.createElement('a');
      a.href = '/tpm/v1/tpmFeeBudgetController/improt/exportTemplate';
      document.body.appendChild(a);
      a.click(); // 下载
      URL.revokeObjectURL(a.href); // 释放URL 对象
      document.body.removeChild(a); // 删除 a 标签
    },
    // 开始上传
    startUpload(type) {
      console.log('开始上传啦');
      const formData = new FormData();
      this.files.map((v) => {
        const item = v;
        formData.append('file', item);
        return item;
      });
      console.log('file', this.files);
      if (!this.files.length) {
        this.$message.error('请选择上传文件');
      } else {
        this.uploadLoading = true;
        if (this.flag) {
          this.flag = false;
          request
            .post('/tpm/v1/tpmFeeBudgetController/improt/changeBatch', formData)
            .then((res) => {
              this.uploadLoading = false;
              if (res.success) {
                this.flag = false;
                if (res.result.length > 0) {
                  const backData = res.result;
                  const now = new Date();
                  const year = now.getFullYear(); // 2025
                  const month = String(now.getMonth() + 1).padStart(2, '0'); // 04（月份从0开始）
                  const day = String(now.getDate()).padStart(2, '0'); // 11
                  const hours = String(now.getHours()).padStart(2, '0'); // 14
                  const minutes = String(now.getMinutes()).padStart(2, '0'); // 51
                  const seconds = String(now.getSeconds()).padStart(2, '0'); // 00（假设秒数为00）

                  // 拼接为 "2025-04-11 14:51:00"
                  const datetime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
                  console.log('时间', datetime);
                  const xhr = new XMLHttpRequest();
                  xhr.open('post', '/tpm/v1/tpmFeeBudgetController/improt/exportErrorDate', true);
                  xhr.setRequestHeader('Content-Type', 'application/json');
                  xhr.setRequestHeader('loginUserToken', Storage.l.get('TokenKey'));
                  xhr.responseType = 'blob';
                  xhr.onreadystatechange = (cres) => {
                    console.log('cres', cres);
                    if (cres.currentTarget.status === 200 && cres.currentTarget.readyState === 4) {
                      const fileName = `费用预算调整异常数据 ${datetime}.xlsx`;
                      const blob = new Blob([cres.currentTarget.response]);
                      const a = document.createElement('a');
                      a.href = URL.createObjectURL(blob);
                      a.download = fileName;
                      a.click();
                    }
                  };
                  xhr.send(JSON.stringify(backData));
                  this.modalConfig.visible = false;
                  console.log('formConfig', this.modalConfig);
                } else {
                  this.$message.success('导入成功');
                  this.modalConfig.visible = false;
                  console.log('formConfig', this.modalConfig);
                }
              }
            })
            .catch(() => {
              this.uploadLoading = false;
              this.flag = false;
            });
        }
      }
    },
    beforeUpload(files) {
      const { name, size } = files;
      let fileType = name.split('.')[name.split('.').length - 1];
      fileType = fileType.toLowerCase();
      const isLt40M = size / 1024 / 1024 <= 40;
      if (this.accept && this.accept.indexOf(fileType) === -1) {
        this.isUpload = true;
        this.$message.warning(
          `当前限制选择 ${this.accept} 类型件，本次选择了错误文件`,
        );
        return false;
      }
      if (!isLt40M) {
        this.loading = false;
        this.$message.error('上传表格大小不超过40MB');
        this.$refs.upload.clearFiles();
        return false;
      }
      return true;
    },
    handleChange(file, fileList) {
      this.files = [];
      fileList.map((v) => {
        const item = v;
        this.files.push(item.raw);
        return item;
      });
    },
    handleRemove(file) {
      this.tableList.forEach((v, k) => {
        if (v.url === file.url) {
          this.tableList.splice(k, 1);
        }
      });
      this.tableList = this.tableList.concat([]);
      this.value.fileList = this.tableList;
      this.$emit('onGetFileList', this.tableList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleSuccess(res) {
      this.isUpload = false;
      if (res.code === 200 && res.success) {
        this.$message.success(res.message);
        res.result.forEach((v) => {
          this.tableList.push({
            fileName: v.fileName,
            url: v.url,
            urlPath: v.urlPath,
            urlPathPrefix: v.urlPathPrefix,
            objectName: v.objectName,
          });
          this.tableList = this.tableList.concat([]);
          this.value.fileList = this.tableList;
          this.$emit('onGetFileList', this.tableList);
        });
      }
    },
    handleExceed(files, fileList) {
      console.log(files, fileList);
    },
    beforeRemove(file) {
      if (!this.isUpload) {
        return this.$confirm(`确定移除 ${file.name}？`);
      }
      this.isUpload = false;

      return true;
    },
    // 创建 websocket 链接
    createWebsocket() {
      if (typeof WebSocket === 'undefined') {
        this.$message.error('您的浏览器不支持socket');
      } else {
        console.log('浏览器支持socket');
      }
      const { sid } = this.formConfig;
      this.sid = sid;
      const token = JSON.parse(localStorage.getItem('userInfo')).loginUserToken;
      console.log(
        `${websocketUrl}/excel/websocket/user?sid=${sid}&&token=${token}`,
      );
      // 根据业务类型 wsUrl 拼接

      this.websocket = new ReconnectingWebSocket(
        `${websocketUrl}/excel/websocket/user?sid=${sid}&&token=${token}`,
      );
      // 连接发生错误的回调方法
      this.websocket.onerror = this.websocketOnerror;
      // 连接成功建立的回调方法
      this.websocket.onopen = this.websocketOnopen;
      // 接收到消息的回调方法
      this.websocket.onmessage = (event) => {
        this.websocketOnmessage(event, sid);
      };
      // 连接关闭的回调方法
      this.websocket.onclose = this.websocketOnclose;
      // 监听窗口关闭事件，当窗口关闭时，主动去关闭websocket连接，防止连接还没断开就关闭窗口，server端会抛异常。
      this.websocket.onbeforeunload = this.websocketOnbeforeunload;
    },
    // 连接发生错误的回调方法
    websocketOnerror() {
      console.log('连接发生错误的回调方法');
    },
    // 连接成功建立的回调方法
    websocketOnopen() {
      console.log('连接成功建立的回调方法');
    },
    // 接收到消息的回调方法
    websocketOnmessage(event) {
      console.log(event);
      const data = JSON.parse(event.data);
      // console.log('接收到消息的回调方法', data);
      this.formConfig.exportMessage += `${data.message}<br/>`;
      // 滑动条移动到最底部
      this.$nextTick(() => {
        const div = document.getElementsByClassName('modal-scrollbar')[0];
        div.scrollTop = div.scrollHeight;
      });
    },
    // 连接关闭的回调方法
    websocketOnclose() {
      console.log('连接关闭的回调方法');
    },
    // 监听窗口关闭事件，当窗口关闭时，主动去关闭websocket连接，防止连接还没断开就关闭窗口，server端会抛异常
    websocketOnbeforeunload() {
      this.closeWebSocket();
      console.log(
        '监听窗口关闭事件，当窗口关闭时，主动去关闭websocket连接，防止连接还没断开就关闭窗口，server端会抛异常',
      );
    },
    // 关闭WebSocket连接
    closeWebSocket() {
      console.log('关闭');
      this.websocket.close();
    },
  },
};
</script>
<style lang="less" scoped>
.dialog-footer {
  position: absolute;
  bottom: 0;
  right: 20px;
  display: flex;
  justify-content: flex-end;
  width: 100%;
  z-index: 99;
  background-color: white;
}
/deep/ .el-upload-dragger,
/deep/ .el-upload {
  width: 98%;
}
.flex {
  display: flex;
  align-items: flex-end;
  .upload-demo {
    flex: 1;
    margin-right: 20px;
  }
}
</style>
